import { MenuOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { Button, Dropdown, MenuProps, message } from 'antd'
import { FC } from 'react'
import connect from '../../../../../../../../helpers/api/connect'
import useGetFlexographyMachines from '../../../../../../../../hooks/api/requests/use-get-flexography-machines'
import useErrorModal from '../../../../../../../../hooks/api/use-error-modal'
import {
    useReorderPrintQueueEntriesMutation,
    useUpdatePrintQueueEntryMutation,
} from '../../../../../../../../store/api/print-queue-entries-api'
import Machine from '../../../../../../../../types/api/machine'
import PrintQueueEntry from '../../../../../../../../types/api/print-queue-entry'
import {
    getDurstPrintDayGroupLabel,
} from '../../../../../helpers/build-durst-print-day-groups'
import { buildMoveToDayReorderPayload } from '../../../../../helpers/move-print-queue-entries-to-day'
import { useDurstQueueContext } from '../../../durst-queue-context'

interface GroupOperationsDropdownProps {
    selected: PrintQueueEntry[]
}

const GroupOperationsDropdown: FC<GroupOperationsDropdownProps> = ({ selected }) => {
    const { data } = useGetFlexographyMachines()
    const machines = data?.data || []
    const durstQueueContext = useDurstQueueContext()
    const [updatePrintQueueEntry, updatePrintQueueEntryState] = useUpdatePrintQueueEntryMutation()
    const [reorder, reorderState] = useReorderPrintQueueEntriesMutation()

    const onChangeQueue = async (machine: Machine) => {
        for (let i = 0; i < selected.length; i++) {
            await updatePrintQueueEntry({
                docId: selected[i].documentId,
                body: {
                    data: {
                        machine: connect(machine),
                        sort: 0, // втыкаем в конец списка
                    },
                },
            })
        }
    }

    const onMoveToPrintDay = async (targetPlannedPrintDate: string) => {
        if (!durstQueueContext) return

        try {
            for (let i = 0; i < selected.length; i++) {
                await updatePrintQueueEntry({
                    docId: selected[i].documentId,
                    body: {
                        data: {
                            plannedPrintDate: targetPlannedPrintDate,
                        },
                    },
                }).unwrap()
            }

            await reorder({
                data: buildMoveToDayReorderPayload({
                    machineEntries: durstQueueContext.machineEntries,
                    selectedEntries: selected,
                    targetPlannedPrintDate,
                }),
            }).unwrap()
        } catch {
            message.error('Не удалось переместить задания на другой день, попробуйте ещё раз')
        }
    }

    useErrorModal(updatePrintQueueEntryState, 'Ошибка обновления очереди')
    useErrorModal(reorderState, 'Ошибка обновления порядка очереди')

    const durstDayItems: MenuProps['items'] = durstQueueContext
        ? Array.from({ length: 11 }, (_, index) => {
              const plannedPrintDate = dayjs().add(index, 'day').format('YYYY-MM-DD')

              return {
                  key: plannedPrintDate,
                  label: getDurstPrintDayGroupLabel(plannedPrintDate),
                  onClick: () => onMoveToPrintDay(plannedPrintDate),
              }
          })
        : []

    const items: MenuProps['items'] = [
        {
            key: '1',
            label: 'Переместить в другую очередь',
            children: machines
                .map(x => x)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(x => ({
                    key: x.documentId,
                    label: x.name,
                    onClick: () => onChangeQueue(x),
                })),
        },
        ...(durstDayItems.length
            ? [
                  {
                      key: '2',
                      label: 'Переместить на другой день',
                      children: durstDayItems,
                  },
              ]
            : []),
    ]
    return (
        <Dropdown menu={{ items }}>
            <Button size={'small'} icon={<MenuOutlined />} />
        </Dropdown>
    )
}

export default GroupOperationsDropdown
